import './emptyMessage.scss'
const EmptyMessage = ({text}) => {
    return (
        <div className='empty-message-container'>
            {text}
        </div>
    )
}
export default EmptyMessage